import React from "react";

const BlogHelp = () => {
	return (
		<div
			id="blog-new-head"
			className="bg-white px-6 py-4 rounded-xl bg-opacity-90 text-sky-500"
		>
			<p>
				Tempat nulis blog apa ajah. Beberapa resource yang mungkin bisa bantu:
			</p>
			<ul className="list-decimal list-inside">
				<li>
					<a
						href="https://commonmark.org/help/"
						target="_blank"
						className="font-bold"
						rel="noreferrer"
					>
						Cheetsheets
					</a>
				</li>
				<li>
					<a
						href="https://markdown-it.github.io/"
						target="_blank"
						className="font-bold"
						rel="noreferrer"
					>
						Testing nulis md
					</a>
				</li>
			</ul>
		</div>
	);
};

export default BlogHelp;
